var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFixed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.21 118H5.78999C2.5476 118 0 115.452 0 112.21V5.78999C0 2.5476 2.5476 0 5.78999 0H112.326C115.568 0 118.116 2.5476 118.116 5.78999V112.326C118 115.452 115.452 118 112.21 118Z",
    fill: "#E15F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3307 111.4L58.9421 101.788C34.9715 77.8176 34.9715 38.9088 58.9421 14.9383L49.3307 5.3269C20.0333 34.5085 20.0333 82.1022 49.3307 111.4ZM88.0078 72.8382L102.483 58.3632L88.0078 43.8882C80.0176 51.8784 79.9018 64.7322 88.0078 72.8382C88.0078 72.8382 87.892 72.7224 88.0078 72.8382ZM68.6692 92.061L78.2806 82.4496C64.9637 69.1326 64.9637 47.478 78.2806 34.1611L68.6692 24.5497C50.0255 43.1934 50.0255 73.4172 68.6692 92.061Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFixed);
export default __webpack_public_path__ + "static/media/logo_fixed.89a91d25a2b8eabcf4e423635007d28d.svg";
export { ForwardRef as ReactComponent };